import { ReactElement, useState } from 'react';
import TicketLinkImportDetailFeature from 'src/app/components/features/ticket-link-imports/TicketLinkImportDetailFeature';
import TicketLinkImportListFeature from 'src/app/components/features/ticket-link-imports/TicketLinkImportListFeature';

export interface TicketLinkImportManagementFeatureProps {
    eventId: string;
}

export default function TicketLinkImportManagementFeature(
    props: Readonly<TicketLinkImportManagementFeatureProps>
): ReactElement {
    const [selectedImport, setSelectedImport] = useState<{
        id: string;
        bookingOptionName: string;
    } | null>(null);

    if (selectedImport !== null) {
        return (
            <TicketLinkImportDetailFeature
                eventId={props.eventId}
                importId={selectedImport.id}
                bookingOptionName={selectedImport.bookingOptionName}
                onBack={() => setSelectedImport(null)}
            />
        );
    }

    return (
        <TicketLinkImportListFeature
            eventId={props.eventId}
            onSelectImport={(id, bookingOptionName) =>
                setSelectedImport({ id, bookingOptionName })
            }
        />
    );
}